// BASE
export const base = {
  FETCH: 'FETCH',
  STORE: 'STORE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
}
// REGISTER
export const register = {
  STEP_1: 'STEP_1',
  STEP_2: 'STEP_2',
  STEP_3: 'STEP_3'
}
// PROFILE
export const profile = {
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPDATE_THEME: 'UPDATE_THEME',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  DELETE_IMAGES: 'DELETE_IMAGES',
  ALERTS: 'ALERTS',
  UPDATE_ALERTS: 'UPDATE_ALERTS',
  RESET_PASSWORD: 'RESET_PASSWORD'
}
// CATALOGS
export const catalogs = {
  FETCH_ALL_DATA: 'FETCH_ALL_DATA',
  FETCH_QUOTE: 'FETCH_QUOTE',
  FETCH_CAREGIVER_SUBCATEGORY: 'FETCH_CAREGIVER_SUBCATEGORY',
}

// Unsubscription
export const unsubscribe = {
  UNSUBSCRIBE_GET: 'UNSUBSCRIBE_GET',
  UNSUBSCRIBE_STORE: 'UNSUBSCRIBE_STORE'
}
// JOBS
export const jobs = {
  JOBS_FIND: 'JOBS_FIND',
  JOBS_GET: 'JOBS_GET',
  JOBS_UPDATE: 'JOBS_UPDATE',
  MATCH_CRITERIA: 'MATCH_CRITERIA',
  RECOMMEND: 'RECOMMEND',
  JOBS_STORE: 'JOBS_STORE'
}
// NANNIES
export const nannies = {
  NANNIES_GET: 'NANNIES_GET',
  NANNIES_FIND: 'NANNIES_FIND',
  MATCH_CRITERIA: 'MATCH_CRITERIA',
  RECOMMEND: 'RECOMMEND',
  NANNIES_CONNECT: 'NANNIES_CONNECT'
}
// PARENTS
export const parents = {
  PARENTS_FIND: 'PARENTS_FIND'
}
// FAVOURITES
export const favourites = {
  FAVOURITES_GET: 'FAVOURITES_GET',
  FAVOURITES_ADD: 'FAVOURITES_ADD',
  FAVOURITES_ADD_NOTE: 'FAVOURITES_ADD_NOTE',
  FAVOURITES_DELETE: 'FAVOURITES_DELETE'
}
// ARTICLES
export const articles = {
  ARTICLES_GET: 'ARTICLES_GET',
  ARTICLES_GET_BY_CATEGORY: 'ARTICLES_GET_BY_CATEGORY',
  ARTICLES_SHOW: 'ARTICLES_SHOW',
  ARTICLES_CATEGORIES: 'ARTICLES_CATEGORIES'
}

export const heardFrom = {
  HEARDFROM_GET: 'HEARDFROM_GET'
}



// WEBPACK FOOTER //
// ./src/store/types/action-types.js